import { useEffect, useState } from "react";

// ui
import {
  Box,
  Button,
  Typography,
} from "@mui/material";
// Table
import { ConstTable } from "../component/Table";

// Modal
import { AccountPasswordModal } from "../component/AccountPasswordModal";
import { CsvAccountInfoModal } from "../component/CsvAccountInfoModal";

// Bar
import TableTopBar from "../component/TableTopBar";
import SerchSideBar from "../component/SerchSideBar";
import AiChatSideBar from "../component/AiChatSideBar";

// Modal
import { DataDetailModal } from "../component/detail/DataDetailModal";
import { DataEditModal } from "../component/DataEditModal";
import { DataAddModal } from "../component/DataAddModal";
import { DataAddModalResult } from "../component/DataAddModalResult";
import { PostCSVModal } from "../component/PostCSVModal";
import { ResetPasswordModal } from "../component/tableFunction/ResetPasswordModal";

// jotai
import { useSetAtom, useAtomValue } from "jotai";
import { AppAtoms } from "../lib/store";

// API
import {
  getAccounts,
  getAccount,
  putAccount,
  postAccount,
  resetPasswordAccount,
} from "../api/account";
import {
  getAccountMgrProducts,
  postAccountMgrProduct,
} from "../api/accountMgrProduct";
import {
  getAccountMgrGroups,
  postAccountMgrGroup,
} from "../api/accountMgrGroup";
import { postSaleCompany } from "../api/saleCompany";
import { getPresignedPostCSV, postPresignedPost } from "../api/presignedURL";
import { getSerchSaleCompanys, getSerchSaleCompanyGroups } from "../api/serch";

// InterFace
import { accountTableColumn } from "../config/account";
import { saleCompanyTableColumn } from "../config/saleCompany";
import {
  dataDifine,
  subDataDifine,
  EditDataDifine,
} from "../config/dataInterface";

// OtherFunc
import { getFirstYear, getOneYear } from "../lib/other";
import { CONST } from "../config/const";

// アカウント登録
const postCSVColumnAccountAdmin = [
  "メールアドレス",
  "氏名",
  "権限",
  "ログイン設定",
  "パートナー",
  "グループ",
  "TEL",
];
const postCSVColumnAccountPartner = [
  "メールアドレス",
  "氏名",
  "権限",
  "ログイン設定",
  "グループ",
  "TEL",
];

function Account() {
  const loginUser = useAtomValue(AppAtoms.loginUser);
  const isSmartPhone = useAtomValue(AppAtoms.isSmartPhone);
  const setIsLoading = useSetAtom(AppAtoms.isLoading);

  // 各権限毎のヘッダーメニューの編集
  const addDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント"],
      name: "パートナー登録",
    },
    {
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      name: "アカウント登録",
    },
  ];
  const addCSVDataTypes: { auth: string[]; name: string }[] = [
    {
      auth: ["マスターアカウント", "スタッフアカウント", "パートナー"],
      name: "アカウントCSV取込",
    },
  ];
  const getXLSXDataTypes: { auth: string[]; name: string }[] = [];
  const editDatasTypes: { auth: string[]; name: string }[] = [];

  const [addDataNames, setAddDataNames] = useState<string[]>([]);
  const [addDataName, setAddDataName] = useState<string>("");
  const [addCSVDataNames, setAddCSVDataNames] = useState<string[]>([]);
  const [addCSVDataName, setAddCSVDataName] = useState<string>("");
  const [getXLSXDataNames, setGetXLSXDataNames] = useState<string[]>([]);
  const [getXLSXDataName, setGetXLSXDataName] = useState<string>("");
  const [editDatasNames, setEditDatasNames] = useState<string[]>([]);
  const [editDatasName, setEditDatasName] = useState<string>("");

  useEffect(() => {
    let addDataNames: string[] = [];
    let addCSVDataNames: string[] = [];
    let getXLSXDataNames: string[] = [];
    let editDatasNames: string[] = [];
    addDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addDataNames.push(dataType.name);
      }
    });
    setAddDataNames(addDataNames);
    addCSVDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        addCSVDataNames.push(dataType.name);
      }
    });
    setAddCSVDataNames(addCSVDataNames);
    getXLSXDataTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        getXLSXDataNames.push(dataType.name);
      }
    });
    setGetXLSXDataNames(getXLSXDataNames);
    editDatasTypes.map((dataType) => {
      if (
        loginUser?.authority &&
        dataType.auth.findIndex(
          (authority) => authority === loginUser.authority
        ) > -1
      ) {
        editDatasNames.push(dataType.name);
      }
    });
    setEditDatasNames(editDatasNames);
  }, [loginUser]);

  useEffect(() => {
    if (addDataName === "パートナー登録") {
      setOnCompanyAddModal(true);
    }
    if (addDataName === "アカウント登録") {
      setOnDataAddModal(true);
    }
  }, [addDataName]);

  useEffect(() => {
    if (addCSVDataName === "アカウントCSV取込") {
      setPostAccountCSVStatus({
        status: "open",
        message: "",
        result: [],
        header_location: "None",
      });
    }
  }, [addCSVDataName]);

  // サブテーブルデータの一覧取得
  const [getSubTableName, setGetSubTableName] = useState<{
    name: string;
    key: { [key: string]: string };
    subData: subDataDifine[];
  }>({
    name: "",
    key: {},
    subData: [],
  });
  useEffect(() => {
    if (getSubTableName.name === "閲覧可能商材一覧") {
      getSubtableDataMgrProduct();
    }
    if (getSubTableName.name === "閲覧可能グループ一覧") {
      getSubtableDataMgrGroup();
    }
  }, [getSubTableName.name, getSubTableName.key]);

  // サブテーブルデータの登録
  const [getSubTableAdd, setGetSubTableAdd] = useState<{
    name: string;
    row: dataDifine | null;
  }>({
    name: "",
    row: null,
  });
  useEffect(() => {
    if (getSubTableAdd.name === "閲覧可能商材追加") {
      openModalSubtableDataAddMgrProduct();
    }
    if (getSubTableAdd.name === "閲覧可能グループ追加") {
      openModalSubtableDataAddMgrGroup();
    }
  }, [getSubTableAdd.name, getSubTableAdd.row]);

  const [tableOriginalFunc, setTableOriginalFunc] = useState<{
    name: string;
    key: { [key: string]: string };
  }>({
    name: "",
    key: {},
  });
  useEffect(() => {
    if (tableOriginalFunc.name === "パスワードリセット") {
      setResetPasswordInf({
        status: "open",
        key: tableOriginalFunc.key,
        message: "",
      });
    }
  }, [tableOriginalFunc.name, tableOriginalFunc.key]);

  // テーブルデータ
  const [fetchData, setFetchData] = useState<dataDifine[]>([]);
  const [totalCount, setTotalCount] = useState<number>(0);

  // データ詳細
  const [dataDetail, setDataDetail] = useState<{
    [key: string]: number | string;
  } | null>(null);

  // データ編集
  const [editData, setEditData] = useState<EditDataDifine | null>(null);

  // データ新規作成
  const addDataColumns = accountTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        if (
          difine.addType === "company" &&
          loginUser?.authority === "パートナー"
        ) {
          return {
            ...column,
            sale_company_id: "dummy_id",
            sale_company_id_name: loginUser?.company,
          };
        } else {
          return {
            ...column,
            [difine.key]: "",
          };
        }
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [addData, setAddData] = useState<{
    [key: string]: string | boolean | any[];
  }>(addDataColumns);
  const [onDataAddModal, setOnDataAddModal] = useState(false);
  const [onDataAddModalResult, setOnDataAddModalResult] = useState("");

  // アカウントパスワード表示モーダル（個別登録）
  const [accountPasswordInfo, setAccountPasswordInfo] = useState<{
    email: string;
    account_name: string;
    temp_password: string;
  } | null>(null);
  // CSVアカウント情報（CSV一括登録後）
  const [csvAccountList, setCsvAccountList] = useState<{
    email: string;
    account_name: string;
    temp_password: string;
  }[]>([]);
  const [onCsvAccountModal, setOnCsvAccountModal] = useState(false);
  const [csvErrorHeaderLocation, setCsvErrorHeaderLocation] = useState<string>("None");

  // パートナー新規作成
  const addCompanyColumns = saleCompanyTableColumn.dataColumn.reduce(
    (column, difine) => {
      if (difine.add) {
        return {
          ...column,
          [difine.key]: "",
        };
      } else {
        return {
          ...column,
        };
      }
    },
    {}
  );
  const [addCompany, setAddCompany] = useState<{
    [key: string]: string | boolean | any[];
  }>(addCompanyColumns);
  const [onCompanyAddModal, setOnCompanyAddModal] = useState(false);

  // 検索欄、テーブル等の高さ
  const [tableHeight, setTableHeight] = useState("calc(100vh - 110px)");
  useEffect(() => {
    const tableHeight = isSmartPhone
      ? "calc(100vh - 190px)"
      : "calc(100vh - 110px)";
    setTableHeight(tableHeight);
  }, [isSmartPhone]);
  const [serchOpen, setSerchOpen] = useState(false);
  const [aiChatOpen, setAiChatOpen] = useState(false);

  // 表示数・ページ
  const [displayNumber, setDisplayNumber] = useState(50);
  const displayNumbers = [25, 50, 100, 250, 500];
  const [pageNumber, setPageNumber] = useState(1);
  const [maxPageNumber, setMaxPageNumber] = useState(1);

  // 検索項目
  const firstYear = getFirstYear();
  const { thisYear, thisMonth, lastYear, lastMonth } = getOneYear();

  const serchColumn = accountTableColumn.dataColumn.reduce((column, difine) => {
    if (difine.serch === true) {
      if (difine.serchType === "date") {
        return {
          ...column,
          [difine.key + "_start"]: "",
          [difine.key + "_end"]: "",
        };
      } else {
        return {
          ...column,
          [difine.key]: "",
        };
      }
    } else {
      return {
        ...column,
      };
    }
  }, {});
  const [serchString, setSerchString] = useState(serchColumn);
  const [serchStringView, setSerchStringView] = useState(serchColumn);

  // 顧客一覧取得
  async function getTableData(edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const fetchData = await getAccounts({
      ...serchString,
      displayNumber,
      pageNumber,
      thisYear: thisYear.toString(),
      thisMonth: thisMonth.toString(),
      lastYear: lastYear.toString(),
      lastMonth: lastMonth.toString(),
    });
    if (fetchData === null) {
      setFetchData([]);
      setTotalCount(0);
      setMaxPageNumber(1);
      setPageNumber(1);
    } else if (fetchData) {
      setFetchData(fetchData.accounts);
      const countAccounts = Number(fetchData.countAccounts);
      setTotalCount(countAccounts);
      setMaxPageNumber(Math.ceil(countAccounts / displayNumber));
    }
    if (!edit) {
      setIsLoading(false);
    }
  }
  useEffect(() => {
    getTableData(false);
  }, [serchString, displayNumber, pageNumber]);

  // 顧客詳細取得
  async function getDataDetail(key: { [key: string]: string }, edit: boolean) {
    if (!edit) {
      setIsLoading(true);
    }
    const id = key.id;
    const dataDetail = await getAccount(
      id,
      thisYear.toString(),
      thisMonth.toString(),
      lastYear.toString(),
      lastMonth.toString()
    );
    setDataDetail(dataDetail);
    if (!edit) {
      setIsLoading(false);
    }
  }

  // 顧客編集
  async function putEditData() {
    if (editData !== null) {
      setIsLoading(true);
      const id = editData.tableId as string;
      setEditData({
        ...editData,
        status: "editing",
      });
      const putResponce = await putAccount(editData);
      await getDataDetail({ id }, true);
      await getTableData(true);
      setEditData({
        ...editData,
        status: putResponce,
      });
      setIsLoading(false);
    }
  }

  // 顧客新規登録
  async function postAddData() {
    setIsLoading(true);
    setOnDataAddModal(false);
    const postResponce = await postAccount(addData);
    if (postResponce?.add === "success") {
      await getTableData(true);
      setAddData(addDataColumns);
      if (postResponce.temp_password) {
        setAccountPasswordInfo({
          email: postResponce.email || "",
          account_name: postResponce.account_name || "",
          temp_password: postResponce.temp_password,
        });
      } else {
        setOnDataAddModalResult("success");
      }
    } else {
      setOnDataAddModal(true);
      setOnDataAddModalResult(postResponce?.add || "");
    }
    setIsLoading(false);
  }

  // アカウント編集用のグループ一覧
  const [groupList, setGroupList] = useState<
    {
      group_id: number;
      group_name: string;
    }[]
  >([]);
  async function getGroupList(id: string) {
    setIsLoading(true);
    const fetchData = await getAccountMgrGroups(id, { forEdit: true });
    setGroupList([
      {
        group_id: 0,
        group_name: "グループに所属しない",
      },
      ...fetchData.groupDatas,
    ]);
    setIsLoading(false);
  }

  // パートナー登録
  async function postAddCompany() {
    setIsLoading(true);
    setOnCompanyAddModal(false);
    const postResponce = await postSaleCompany(addCompany);
    if (postResponce === "success") {
      await getTableData(true);
      await getSaleCompanysList();
      setAddCompany(addDataColumns);
      setOnDataAddModalResult("success");
    } else {
      setOnCompanyAddModal(true);
      setOnDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // CSVアカウント情報ダウンロード
  function downloadCsvAccountInfo() {
    const header = "アカウント名,メールアドレス,初期パスワード\n";
    const rows = csvAccountList.map((acc) =>
      `"${acc.account_name}","${acc.email}","${acc.temp_password}"`
    ).join("\n");
    const csv = "\uFEFF" + header + rows;
    const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "account_info.csv";
    document.body.appendChild(link);
    link.click();
    URL.revokeObjectURL(url);
    document.body.removeChild(link);
  }

  // アカウントCSV取込
  const [postAccountCSVStatus, setPostAccountCSVStatus] = useState<{
    status: "none" | "open" | "posting" | "result" | "loading" | "error";
    message: string;
    result: { [key: string]: any }[];
    header_location: string;
  }>({
    status: "none",
    message: "",
    result: [],
    header_location: "None",
  });
  useEffect(() => {
    if (postAccountCSVStatus.status === "loading") {
      setIsLoading(true);
    } else if (postAccountCSVStatus.status !== "none") {
      setIsLoading(false);
    }
  }, [postAccountCSVStatus]);
  async function postAccountCSV(postDatas: File) {
    setPostAccountCSVStatus({
      status: "loading",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });
    // 著名付きURL(post用)を作成
    const fileName = postDatas.name;
    const date = new Date();
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0"); // 月は0始まりのため+1
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    const nowTimeName = `${year}${month}${day}${hours}${minutes}${seconds}`;
    const { presigned_object, destination_key } = await getPresignedPostCSV(
      nowTimeName,
      fileName
    );
    // POSTする form に持たせるデータを生成する
    const formData = new FormData();
    for (const key in presigned_object.fields) {
      formData.append(key, presigned_object.fields[key]);
    }
    formData.append("file", postDatas);
    // ファイルをS3にアップロード
    await postPresignedPost(presigned_object.url, formData);

    setPostAccountCSVStatus({
      status: "posting",
      message: "CSV情報確認中",
      result: [],
      header_location: "None",
    });

    const path = "account";
    const idToken = loginUser?.idToken;
    const bodys = {
      type: "post_csv",
      path: path,
      destination_key: destination_key,
      idToken,
    };

    // WebSocketオブジェクトを生成しサーバとの接続を開始
    const url = CONST.inputCSVWebSocketAPIURL + "?Authorization=" + idToken;
    const websocket = new WebSocket(url);
    // メッセージ受信時のイベントハンドラを設定
    const onMessage = async (event_websocket: any) => {
      const decodedData = JSON.parse(event_websocket.data);
      if (decodedData.message === "success") {
        setPostAccountCSVStatus({
          status: "loading",
          message: "CSV取込完了",
          result: postAccountCSVStatus.result,
          header_location: decodedData.header_location,
        });
        await getTableData(false);
        // アカウント情報を収集（パスワード表示用）— エラーメールアドレスを除外
        const errorEmails = new Set(
          (postAccountCSVStatus.result as any[])
            .filter((r: any) => r.postData && r.message)
            .map((r: any) => r.postData["メールアドレス"] as string)
            .filter(Boolean)
        );
        const accountInfoList = (postAccountCSVStatus.result as any[])
          .filter((r: any) => r.account_info)
          .map((r: any) => r.account_info as { email: string; account_name: string; temp_password: string })
          .filter((acc) => acc.temp_password && !errorEmails.has(acc.email));
        setCsvErrorHeaderLocation(decodedData.header_location);
        if (accountInfoList.length > 0) {
          setCsvAccountList(accountInfoList);
          setPostAccountCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
          setOnCsvAccountModal(true);
        } else {
          // 登録成功0件 → PostCSVModalの結果画面を通常表示（エラーテーブル）
          setPostAccountCSVStatus({
            status: "result",
            message: "CSV取込完了",
            result: (postAccountCSVStatus.result as any[]).filter((r: any) => !r.account_info),
            header_location: decodedData.header_location,
          });
        }
        websocket.close();
      } else if (decodedData.message === "header_error") {
        setPostAccountCSVStatus({
          status: "error",
          message:
            "「" + decodedData.header + "」がCSV項目に含まれていません。",
          result: [],
          header_location: "None",
        });
        websocket.close();
      } else if (
        decodedData.message !== "End_WebSocket_API" &&
        decodedData.message !== "Endpoint request timed out"
      ) {
        let _result = postAccountCSVStatus.result;
        if (decodedData.res_results) {
          _result.push(decodedData.res_results);
        }
        setPostAccountCSVStatus({
          status: "posting",
          message: decodedData.message,
          result: _result,
          header_location: "None",
        });
      }
    };
    websocket.onmessage = onMessage;
    websocket.onopen = () => websocket.send(JSON.stringify(bodys));
  }

  // サブテーブルデータの登録結果（共通）
  const [onSubtableDataAddModalResult, setOnSubtableDataAddModalResult] =
    useState("");

  // MGR閲覧可能商材一覧取得
  async function getSubtableDataMgrProduct() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getAccountMgrProducts(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // MGR閲覧可能商材登録
  const [addDataMgrProduct, setAddDataMgrProduct] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    account_id: "",
    all_product: [],
    select_product: [],
  });
  const [onDataAddModalMgrProduct, setOnDataAddModalMgrProduct] =
    useState(false);
  async function openModalSubtableDataAddMgrProduct() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getAccountMgrProducts(
        getSubTableAdd.row.id as string
      );
      setAddDataMgrProduct({
        account_id: getSubTableAdd.row.id as string,
        all_product: fetchData.productDatas,
        select_product: fetchData.sudDatas,
      });
      setOnDataAddModalMgrProduct(true);
      setIsLoading(false);
    }
  }
  async function postAddDataMgrProduct() {
    setIsLoading(true);
    setOnDataAddModalMgrProduct(false);
    const postResponce = await postAccountMgrProduct(addDataMgrProduct);
    if (postResponce === "success") {
      if (getSubTableName.name == "閲覧可能商材一覧") {
        await getSubtableDataMgrProduct();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataMgrProduct({
        account_id: "",
        all_product: [],
        select_product: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalMgrProduct(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // MGR閲覧可能グループ一覧取得
  async function getSubtableDataMgrGroup() {
    if (getSubTableName.key.id) {
      setIsLoading(true);
      const fetchData = await getAccountMgrGroups(getSubTableName.key.id);
      setGetSubTableName({
        ...getSubTableName,
        subData: fetchData.sudDatas,
      });
      setIsLoading(false);
    }
  }

  // MGR閲覧可能グループ登録
  const [addDataMgrGroup, setAddDataMgrGroup] = useState<{
    [key: string]: string | boolean | any[];
  }>({
    account_id: "",
    all_group: [],
    select_group: [],
  });
  const [onDataAddModalMgrGroup, setOnDataAddModalMgrGroup] = useState(false);
  async function openModalSubtableDataAddMgrGroup() {
    if (getSubTableAdd.row) {
      setIsLoading(true);
      const fetchData = await getAccountMgrGroups(
        getSubTableAdd.row.id as string
      );
      setAddDataMgrGroup({
        account_id: getSubTableAdd.row.id as string,
        all_group: fetchData.groupDatas,
        select_group: fetchData.sudDatas,
      });
      setOnDataAddModalMgrGroup(true);
      setIsLoading(false);
    }
  }
  async function postAddDataMgrGroup() {
    setIsLoading(true);
    setOnDataAddModalMgrGroup(false);
    const postResponce = await postAccountMgrGroup(addDataMgrGroup);
    if (postResponce === "success") {
      if (getSubTableName.name == "閲覧可能グループ一覧") {
        await getSubtableDataMgrGroup();
      }
      setIsLoading(true);
      await getTableData(true);
      setAddDataMgrGroup({
        account_id: "",
        all_group: [],
        select_group: [],
      });
      setOnSubtableDataAddModalResult("success");
    } else {
      setOnDataAddModalMgrGroup(true);
      setOnSubtableDataAddModalResult(postResponce);
    }
    setIsLoading(false);
  }

  // データ無効化
  const [resetPasswordInf, setResetPasswordInf] = useState<{
    status: null | "loading" | "open" | "success" | "failed";
    key: { [key: string]: string };
    message: string;
  }>({
    status: null,
    key: {},
    message: "",
  });
  async function resetPassword() {
    setResetPasswordInf({
      ...resetPasswordInf,
      status: "loading",
    });
    const id = resetPasswordInf.key.id;
    const responce = await resetPasswordAccount(id);
    if (responce?.edit === "success") {
      await getTableData(false);
      setResetPasswordInf({
        ...resetPasswordInf,
        status: "success",
        key: {
          ...resetPasswordInf.key,
          temp_password: responce.temp_password || "",
          email: responce.email || "",
          account_name: responce.account_name || "",
        },
      });
    } else {
      setResetPasswordInf({
        ...resetPasswordInf,
        status: "failed",
        message: responce?.edit || "failed",
      });
    }
  }
  useEffect(() => {
    if (resetPasswordInf.status === "loading") {
      setIsLoading(true);
    } else if (resetPasswordInf.status !== null) {
      setIsLoading(false);
    }
  }, [resetPasswordInf]);

  // グループ一覧取得
  const [searchGroupList, setSearchGroupList] = useState<
    {
      id: number;
      group_name: string;
      sale_company_id: number;
    }[]
  >([]);
  const [searchGroupNameList, setSearchGroupNameList] = useState([""]);
  async function getSaleCompanyGroupsList() {
    const fetchData = await getSerchSaleCompanyGroups();
    if (fetchData === null) {
      setSearchGroupList([]);
    } else if (fetchData) {
      setSearchGroupList(
        fetchData.saleCompanyGroups as {
          id: number;
          group_name: string;
          sale_company_id: number;
        }[]
      );
      let searchGroupNameList = [""];
      fetchData.saleCompanyGroups.map(
        (company: { id: number; group_name: string }) => {
          if (!searchGroupNameList.includes(company.group_name)) {
            searchGroupNameList.push(company.group_name);
          }
        }
      );
      setSearchGroupNameList(searchGroupNameList);
    }
  }
  // アカウント登録用のグループ一覧
  const [addDataGroupList, setAddDataGroupList] = useState<
    {
      id: number;
      group_name: string;
      sale_company_id: number;
    }[]
  >([]);
  useEffect(() => {
    if (loginUser?.authority === "パートナー") {
      setAddDataGroupList([
        {
          id: 0,
          group_name: "グループに所属しない",
          sale_company_id: 0,
        },
        ...searchGroupList,
      ]);
    } else {
      let addDataGroupList: {
        id: number;
        group_name: string;
        sale_company_id: number;
      }[] = [];
      searchGroupList.map((group) => {
        if (Number(addData.sale_company_id) == group.sale_company_id) {
          addDataGroupList.push(group);
        }
      });
      setAddDataGroupList([
        {
          id: 0,
          group_name: "グループに所属しない",
          sale_company_id: 0,
        },
        ...addDataGroupList,
      ]);
    }
  }, [searchGroupList, addData.sale_company_id]);
  // パートナー一覧取得
  const [companyList, setCampanyList] = useState<
    { id: number; sale_company_name: string }[]
  >([]);
  const [companyNameList, setCampanyNameList] = useState([""]);
  async function getSaleCompanysList() {
    const fetchData = await getSerchSaleCompanys();
    if (fetchData === null) {
      setCampanyList([]);
    } else if (fetchData) {
      setCampanyList(
        fetchData.saleCompanys as { id: number; sale_company_name: string }[]
      );
      let companyNameList = [""];
      fetchData.saleCompanys.map(
        (company: { id: number; sale_company_name: string }) => {
          if (!companyNameList.includes(company.sale_company_name)) {
            companyNameList.push(company.sale_company_name);
          }
        }
      );
      setCampanyNameList(companyNameList);
    }
  }
  useEffect(() => {
    getSaleCompanysList();
    getSaleCompanyGroupsList();
  }, []);

  const handleSetSerchOpen = (open: boolean) => {
    setSerchOpen(open);
    if (open) setAiChatOpen(false);
  };
  const handleSetAiChatOpen = (open: boolean) => {
    setAiChatOpen(open);
    if (open) setSerchOpen(false);
  };

  return (
    <Box
      data-testid="account-page"
      style={{
        width: isSmartPhone
          ? "calc(100% - 31px)"
          : (serchOpen || aiChatOpen)
          ? "calc(100% - 331px)"
          : "calc(100% - 31px)",
        height: isSmartPhone ? "calc(100vh - 120px)" : "calc(100vh - 40px)",
      }}
    >
      <TableTopBar
        serch={true}
        serchOpen={serchOpen}
        setSerchOpen={handleSetSerchOpen}
        addDataNames={addDataNames}
        addDataName={addDataName}
        setAddDataName={setAddDataName}
        addCSVDataNames={addCSVDataNames}
        addCSVDataName={addCSVDataName}
        setAddCSVDataName={setAddCSVDataName}
        getXLSXDataNames={getXLSXDataNames}
        getXLSXDataName={getXLSXDataName}
        setGetXLSXDataName={setGetXLSXDataName}
        editDatasNames={editDatasNames}
        editDatasName={editDatasName}
        setEditDatasName={setEditDatasName}
        editIDs={[]}
        columnSettingOpen={false}
        openColumnSettingWindow={() => {}}
        aiChatOpen={aiChatOpen}
        setAiChatOpen={handleSetAiChatOpen}
      />
      <Box style={{ display: "flex" }}>
        {(serchOpen || aiChatOpen) && isSmartPhone ? null : (
          <Box
            style={{
              width: isSmartPhone ? undefined : "100%",
              margin: isSmartPhone ? undefined : "10px 15px",
              height: isSmartPhone ? undefined : tableHeight,
              maxHeight: isSmartPhone ? undefined : tableHeight,
            }}
          >
            <ConstTable
              getTableData={getTableData}
              tableType={"main"}
              serchOpen={serchOpen}
              aiChatOpen={aiChatOpen}
              tableHeight={tableHeight}
              tableColumn={accountTableColumn}
              dataColumn={[]}
              rows={fetchData}
              displayNumber={displayNumber}
              setDisplayNumber={setDisplayNumber}
              displayNumbers={displayNumbers}
              pageNumber={pageNumber}
              setPageNumber={setPageNumber}
              maxPageNumber={maxPageNumber}
              totalCount={totalCount}
              getDataDetail={getDataDetail}
              getSubTableName={getSubTableName}
              setGetSubTableName={setGetSubTableName}
              getSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubTableDetail={() => {}}
              setGetSubTableAdd={setGetSubTableAdd}
              setGetSubTableEditDirect={() => {}}
              getSubSubTableName={{
                name: "",
                key: {},
                subData: [],
              }}
              setGetSubSubTableName={() => {}}
              getSubSubTableDetail={{
                name: "",
                key: {},
                dataDetail: null,
              }}
              setGetSubSubTableDetail={() => {}}
              setGetSubSubTableAdd={() => {}}
              setGetSubSubTableEditDirect={() => {}}
              tableTitle={accountTableColumn.title}
              switchTableCheckBox={() => {}}
              allCheckFlg={false}
              switchAllTableCheckBox={() => {}}
              editIDs={[]}
              setEditIDs={() => {}}
              setEditDatasName={setEditDatasName}
              setGetSubMainTableName={() => {}}
              setTableOriginalFunc={setTableOriginalFunc}
              sortColumn={[]}
              setSortColumn={() => {}}
            />
          </Box>
        )}
        {serchOpen ? (
          <SerchSideBar
            setSerchOpen={handleSetSerchOpen}
            tableHeight={tableHeight}
            tableColumn={accountTableColumn}
            dataColumn={[]}
            firstYear={firstYear}
            thisYear={thisYear}
            serchColumn={serchColumn}
            setSerchString={setSerchString}
            companyNameList={companyNameList}
            companyGroupNameList={[]}
            highRankCompanyNameList={[]}
            categoryNameList={[]}
            productNameList={[]}
            accountSaleNameList={[]}
            accountStaffNameList={[]}
            serchStringView={serchStringView}
            setSerchStringView={setSerchStringView}
          />
        ) : null}
        {aiChatOpen && (
          <AiChatSideBar
            open={aiChatOpen}
            setOpen={handleSetAiChatOpen}
            pageName="Account"
          />
        )}
      </Box>
      <DataDetailModal
        onModal={
          dataDetail !== null &&
          ((editData !== null && editData.status !== "editing") ||
            editData === null)
        }
        swCloseModal={() => setDataDetail(null)}
        detailTitle={accountTableColumn.detailTitle}
        editAuth={accountTableColumn.editAuth}
        dataColumn={accountTableColumn.dataColumn}
        subDataColumn={[]}
        dataDetail={dataDetail}
        setEditData={setEditData}
        option={false}
        setEditProduct={() => {}}
        dataDetailOption={[]}
        dataDetailOptionSelect={[]}
        dataDetailHistory={[]}
        selectHistory={0}
        getOldDataDetail={() => {}}
        getGroupList={getGroupList}
        setEditProductOptionPlans={() => {}}
        setEditProductOptionContents={() => {}}
        setEditTossUpFormOptionProducts={() => {}}
        setEditOutsideServices={() => {}}
        setSelectServiseInfo={() => {}}
        setSelectTossUpInfo={() => {}}
      />
      <DataEditModal
        onModal={editData !== null && editData.status !== "editing"}
        swCloseModal={() => setEditData(null)}
        editData={editData}
        setEditData={setEditData}
        putEditData={putEditData}
        groupList={groupList}
        categoryList={[]}
        accountCollaborateCompanySaleList={[]}
        selectServiseInfo={{
          service_plan_data: [],
          service_content_data: [],
          service_campaign_pulldown_data: [],
          service_campaign_checkbox_data: [],
        }}
        selectTossUpInfo={{
          tossUpCategoryNameList: [],
          tossUpProductNameList: [],
        }}
      />
      <DataAddModal
        onModal={onDataAddModal}
        swCloseModal={() => {
          setOnDataAddModal(false);
          setAddDataName("");
        }}
        addTitle={accountTableColumn.addTitle}
        dataColumn={accountTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddData}
        addData={addData}
        setAddData={setAddData}
        companyList={companyList}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={addDataGroupList}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onCompanyAddModal}
        swCloseModal={() => {
          setOnCompanyAddModal(false);
          setAddDataName("");
        }}
        addTitle={saleCompanyTableColumn.addTitle}
        dataColumn={saleCompanyTableColumn.dataColumn}
        subDataColumn={[]}
        postAddData={postAddCompany}
        addData={addCompany}
        setAddData={setAddCompany}
        companyList={companyList}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalMgrProduct}
        swCloseModal={() => {
          setOnDataAddModalMgrProduct(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={accountTableColumn.subTable[0].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={accountTableColumn.subTable[0].subDataColumn}
        postAddData={postAddDataMgrProduct}
        addData={addDataMgrProduct}
        setAddData={setAddDataMgrProduct}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModal
        onModal={onDataAddModalMgrGroup}
        swCloseModal={() => {
          setOnDataAddModalMgrGroup(false);
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addTitle={accountTableColumn.subTable[1].subTableAddTitle}
        dataColumn={[]}
        subDataColumn={accountTableColumn.subTable[1].subDataColumn}
        postAddData={postAddDataMgrGroup}
        addData={addDataMgrGroup}
        setAddData={setAddDataMgrGroup}
        companyList={[]}
        highRankCompanyList={[]}
        staffList={[]}
        firstYear={firstYear}
        thisYear={thisYear}
        productList={[]}
        categoryList={[]}
        groupList={[]}
        postFiles={{}}
        setPostFiles={() => {}}
        sitePathList={[]}
      />
      <DataAddModalResult
        onModal={onDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnDataAddModalResult("");
          setAddDataName("");
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onDataAddModalResult}
      />
      <DataAddModalResult
        onModal={onSubtableDataAddModalResult !== ""}
        swCloseModal={() => {
          setOnSubtableDataAddModalResult("");
          setGetSubTableAdd({
            name: "",
            row: null,
          });
        }}
        addModalTitle={"新規作成"}
        onDataAddModalResult={onSubtableDataAddModalResult}
      />
      <PostCSVModal
        onModal={
          postAccountCSVStatus.status !== "none" &&
          postAccountCSVStatus.status !== "loading"
        }
        swCloseModal={() => {
          setPostAccountCSVStatus({
            status: "none",
            message: "",
            result: [],
            header_location: "None",
          });
          setAddCSVDataName("");
          setCsvAccountList([]);
        }}
        postCSVStatus={postAccountCSVStatus}
        setPostCSVStatus={setPostAccountCSVStatus}
        postCSVFunc={postAccountCSV}
        postCSVTitle={"アカウントCSV取込"}
        postCSVColumn={
          loginUser?.authority === "パートナー"
            ? postCSVColumnAccountPartner
            : postCSVColumnAccountAdmin
        }
        postCSVColumnResult={
          loginUser?.authority === "パートナー"
            ? postCSVColumnAccountPartner
            : postCSVColumnAccountAdmin
        }
        postCSVPath={"account"}
        productList={[]}
        categoryList={[]}
      />
      <ResetPasswordModal
        onModal={
          resetPasswordInf.status !== null &&
          resetPasswordInf.status !== "loading"
        }
        swCloseModal={() => {
          setResetPasswordInf({
            status: null,
            key: {},
            message: "",
          });
          setTableOriginalFunc({
            name: "",
            key: {},
          });
        }}
        resetPassword={resetPassword}
        setResetPasswordInf={setResetPasswordInf}
        resetPasswordInf={resetPasswordInf}
      />
      <AccountPasswordModal
        accountPasswordInfo={accountPasswordInfo}
        onClose={() => {
          setAccountPasswordInfo(null);
          setAddDataName("");
        }}
      />
      <CsvAccountInfoModal
        open={onCsvAccountModal}
        onClose={() => {
          setOnCsvAccountModal(false);
          setCsvAccountList([]);
        }}
        accountList={csvAccountList}
        errorHeaderLocation={csvErrorHeaderLocation}
        onDownloadCsv={downloadCsvAccountInfo}
      />
    </Box>
  );
}

export default Account;
